import { render, staticRenderFns } from "./ServiceDetailsModal.vue?vue&type=template&id=1ea948ac&scoped=true&"
import script from "./ServiceDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailsModal.vue?vue&type=style&index=0&id=1ea948ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea948ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea948ac')) {
      api.createRecord('1ea948ac', component.options)
    } else {
      api.reload('1ea948ac', component.options)
    }
    module.hot.accept("./ServiceDetailsModal.vue?vue&type=template&id=1ea948ac&scoped=true&", function () {
      api.rerender('1ea948ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ServiceDetailsModal.vue"
export default component.exports